export const adminActionTypes = {
    ADD_ADMIN: "ADD_ADMIN",
    ADD_BUTTON: "ADD_BUTTON"
};